import { render, staticRenderFns } from "./WapWXCW03BJRecord1Day.vue?vue&type=template&id=019f24ba&"
import script from "./WapWXCW03BJRecord1Day.vue?vue&type=script&lang=js&"
export * from "./WapWXCW03BJRecord1Day.vue?vue&type=script&lang=js&"
import style0 from "./WapWXCW03BJRecord1Day.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports